import { useMutation } from '@tanstack/react-query'
import { IApiBaseTypes } from '@/types/query-api'
import { APIInstance } from '@/utils/functions/instance'
import { ILoginQueryParamsType } from './type'

export function useLogin({
  disableToast,
  ...rest
}: Omit<IApiBaseTypes<ILoginQueryParamsType>, 'data'>) {
  return useMutation({
    mutationFn: async (data: ILoginQueryParamsType) =>
      await APIInstance<string>({
        url: 'user/login/',
        method: 'post',
        data
      }),
    retry: 0,
    mutationKey: ['loginOtp'],
    ...rest
  })
}
